/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
import acl from './acl/acl'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        // for admin user
        {
          path: '/',
          name: 'dashboard',
          component: () => import('./views/admin/Dashboard.vue'),
          meta: {
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/customers',
          name: 'customers',
          component: () => import('./views/admin/Customers.vue'),
          meta: {
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/customer-albums/:custID',
          name: 'customer-albums',
          component: () => import('./views/admin/Albums.vue'),
          meta: {
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/nursing-homes',
          name: 'nursing-homes',
          component: () => import('./views/admin/NursingHomes.vue'),
          meta: {
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/nh-staff/:nhID',
          name: 'nursing-home-staff',
          component: () => import('./views/admin/Staff.vue'),
          meta: {
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/nh-payments',
          name: 'nh-payments',
          component: () => import('./views/admin/Payments.vue'),
          meta: {
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/coupons',
          name: 'admin-coupons',
          component: () => import('./views/admin/coupons/Coupons.vue'),
          meta: {
            requiresAuth: true,
            rule: 'admin'
          }
        },
        // for Nursing Home Admin user
        {
          path: '/nh-admin',
          name: 'nh-dashboard',
          component: () => import('./views/nursing-home-admin/user-list/UserList.vue'),
          meta: {
            requiresAuth: true,
            rule: 'nh_admin'
          }
        },
        {
          path: '/nh-coupons',
          name: 'nh-coupons',
          component: () => import('./views/nursing-home-admin/coupons/Coupons.vue'),
          meta: {
            requiresAuth: true,
            rule: 'nh_admin'
          }
        },
        {
          path: '/nh-invitations',
          name: 'nh-invitations',
          component: () => import('./views/nursing-home-admin/Invitations.vue'),
          meta: {
            requiresAuth: true,
            rule: 'nh_admin'
          }
        },
        {
          path: '/nh-albums',
          name: 'nh-albums',
          component: () => import('./views/nursing-home-admin/Albums.vue'),
          meta: {
            requiresAuth: true,
            rule: 'nh_admin'
          }
        },

        // for Nursing home staff member
        {
          path: '/nhs-albums',
          name: 'nhs-albums',
          component: () => import('./views/nursing-home-staff/Albums.vue'),
          meta: {
            requiresAuth: true,
            rule: 'nh_staff'
          }
        },

        // Prfile page
        {
          path: '/profile',
          name: 'profile',
          component: () => import('@/views/pages/Profile.vue'),
          meta: {
            requiresAuth: true,
            rule: 'public'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'public'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.name === 'dashboard') {
        if (store.state.AppActiveUser.userRole == 'nh_admin') {
          next('/nh-admin')
          return
        } else if (store.state.AppActiveUser.userRole == 'nh_staff') {
          next('/nhs-albums')
          return
        } else {
          next()
          return
        }
      }
      next()
      return
    }
    next('/login')
  } else {
    if (to.name === 'login') {
      if (store.getters.isLoggedIn) {
        if (store.state.AppActiveUser.userRole == 'nh-admin') { next('/nh-admin') } else if (store.state.AppActiveUser.userRole == 'nh_staff') { next('/nhs-albums') } else { next('/') }
        return
      }
    }
    next()
  }
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
